import React from 'react';

const PatientAppointmentTableHeader = ({ onSortByDate, isSortAsc }) => {
    return (
        <div className="bg-white border-b border-gray-200">
            <div className="grid grid-cols-8 gap-4 p-4" style={{gridTemplateColumns: '40px 1fr 1fr 1.2fr 1fr 1.5fr 1fr 1fr'}}>
                {/* Arrow column - empty header */}
                <div className="hidden lg:block text-xs font-medium text-gray-500 uppercase tracking-wider"></div>
                
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">Speciality</div>
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">Appointment For</div>
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <SortButton onClick={onSortByDate} isSortAsc={isSortAsc} />
                </div>
                <div className="hidden lg:block text-xs font-medium text-gray-500 uppercase tracking-wider">Urgency</div>
                <div className="hidden lg:block text-xs font-medium text-gray-500 uppercase tracking-wider">Clinic</div>
                <div className="hidden lg:block text-xs font-medium text-gray-500 uppercase tracking-wider">Status</div>
                <div className="hidden lg:block text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</div>
            </div>
        </div>
    );
};

const SortButton = ({ onClick, isSortAsc }) => {
    return (
        <button onClick={onClick} className="flex items-center gap-2 hover:text-blue-600 transition-colors duration-200">
            <span className="uppercase">Requested On</span>
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-100 hover:bg-blue-100 transition-colors duration-200">
                {!isSortAsc ? (
                    <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                ) : (
                    <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                )}
            </span>
        </button>
    );
};

export default PatientAppointmentTableHeader;
